import { application } from './application'
import ChartController from './chart_controller'
import ChartGeoController from './chart_geo_controller'
import ChoicesController from './choices_controller'
import ClipboardController from './clipboard_controller'
import DialogController from './dialog_controller'
import EmailController from './email_controller'
import HiddenFieldController from './hidden_field_controller'
import ModalController from './modal_controller'
import SortableController from './sortable_controller'

application.register('chart-geo', ChartGeoController)
application.register('chart', ChartController)
application.register('choices', ChoicesController)
application.register('clipboard', ClipboardController)
application.register('dialog', DialogController)
application.register('email', EmailController)
application.register('hidden-field', HiddenFieldController)
application.register('modal', ModalController)
application.register('sortable', SortableController)
